module.exports = __webpack_public_path__ + "img/Add Patient - Gray.f2ff5730.png";